<!-- CareTeamMembersToolTip.vue -->
<script setup lang="ts">
    import { PatientCareTeamMemberModel } from '../../../lib/Api/Patient';
    import Phone from '../../Formatting/Phone.vue';
    import XSpan from '../../HtmlWrapper/XSpan.vue';
    import ToolTipGridContainer from '../../Table/ToolTipGridContainer.vue';
    import ToggleIcon from '../../ToggleIcon.vue';
    import PatientHeaderToolTipItem from './PatientHeaderToolTipItem.vue';
    import { reactive, watch, onMounted } from 'vue';
    
    const props = defineProps<{
        teamMembers?: PatientCareTeamMemberModel[],
        hideCareTeamHeader?: boolean
    }>();

    const compData = reactive<{
        showCareTeamMemberDetails: boolean[]
    }>({
        showCareTeamMemberDetails: []
    });

    onMounted(() =>{
        resetCareTeamMembersToggleState();        
    });

    watch(() => props.teamMembers, (newVal, oldVal) =>{
        resetCareTeamMembersToggleState();
    });

    function resetCareTeamMembersToggleState()
    {
        // Reset care team member display state
        compData.showCareTeamMemberDetails = new Array<boolean>(props.teamMembers?.length ?? 0);
        for(let i=0; i < compData.showCareTeamMemberDetails.length; ++i)
        {
            compData.showCareTeamMemberDetails[i] = false;
        }
    }
</script>

<style scoped>
    @import url('../../../../css/toolTipGrid.css');

    /* dfltvw.css has a rule that messes with layouts that use SPAN elements */
    p {
        font-size: small
    }
</style>

<template>
    <template v-if="props.teamMembers">
        <ToolTipGridContainer>
            <PatientHeaderToolTipItem v-if="!hideCareTeamHeader">
                <XSpan class="tool-tip-section-header">
                    Care Team Members
                </XSpan>
            </PatientHeaderToolTipItem>

            <template v-for="(member, index) in props.teamMembers">
                <PatientHeaderToolTipItem :topBorder="index > 0">
                    <template #title>
                        Name
                    </template>
                    <ToggleIcon 
                            v-model:folded="compData.showCareTeamMemberDetails[index]" 
                            :foldedValue="false"
                            :title="compData.showCareTeamMemberDetails[index] ? 'Click to hide details' : 'Click to show details'"/>
                    {{ member.name }}
                </PatientHeaderToolTipItem>

                <template v-if="true === compData.showCareTeamMemberDetails[index]">
                    <PatientHeaderToolTipItem>
                        <template #title>
                            Type
                        </template>
                        {{ member.careTeamTypeDesc }}
                    </PatientHeaderToolTipItem>

                    <PatientHeaderToolTipItem v-if="member.careTeamRoleDesc">
                        <template #title>
                            Role
                        </template>
                        {{ member.careTeamRoleDesc }}
                    </PatientHeaderToolTipItem> 

                    <PatientHeaderToolTipItem>
                        <template #title>
                            Company
                        </template>
                        {{ member.company }}
                    </PatientHeaderToolTipItem>
                    
                    <PatientHeaderToolTipItem>
                        <template #title>
                            Address
                        </template>
                        {{ member.address }}
                    </PatientHeaderToolTipItem>      

                    <PatientHeaderToolTipItem v-if="member.npi">
                        <template #title>
                            NPI
                        </template>
                        {{ member.npi }}
                    </PatientHeaderToolTipItem>       

                    <PatientHeaderToolTipItem>
                        <template #title>
                            Phone
                        </template>
                        <Phone :phone="member.phone" />
                    </PatientHeaderToolTipItem>      
    
                    <PatientHeaderToolTipItem>
                        <template #title>
                            Fax
                        </template>
                        <Phone :phone="member.fax" />
                    </PatientHeaderToolTipItem>
                </template>
            </template>
        </ToolTipGridContainer>
    </template>
</template>